function formatDate(date){
    if(date){
        let year = date.substring(0, 4);
        let month = date.substring(5, 7);
        let day = date.substring(8, 10);
        return `${year}-${month}-${day}`;
    }
}

export function handleInput(e, kind, data, setData){
    //Deal with Input Text
    if(e.target){
        switch(e.target.name) {
            case "name":
                setData( data = { ...data,
                    name: e.target.value
                })
                return null
            case "document":
                setData( data = { ...data,
                    document: e.target.value
                })
                return null
            case "email":
                    setData( data = { ...data,
                        email: e.target.value
                    })
                return null
            case "password":
                    setData( data = { ...data,
                        password: e.target.value
                    })
                return null
            case "confirmPassword":
                    setData( data = { ...data,
                        confirmPassword: e.target.value
                    })
                return null
            case "cep":
                setData( data = { ...data,
                    cep: e.target.value
                })
                return null
            case "address":
                setData( data = { ...data,
                    address: e.target.value
                })
                return null
            case "number":
                setData( data = { ...data,
                    number: e.target.value
                })
                return null
            case "neighborhood":
                setData( data = { ...data,
                    neighborhood: e.target.value
                })
                return null
            case "city":
                setData( data = { ...data,
                    city: e.target.value
                })
                return null
            case "phone":
                setData( data = { ...data,
                    phone: e.target.value
                })
                return null
            case "celphone":
                setData( data = { ...data,
                    celphone: e.target.value
                })
                return null
            default:
                break;
        }
    //Deal with Date fields
    }else if(e._locale && kind === "Data de Nascimento"){
        let date = formatDate(e.format())
        setData( data = { ...data,
            dateOfBirth: date
        })
    }else{
        if(kind === "country"){
            setData( data = { ...data,
                country: e
            });
            return null
        }else if(kind === "uf"){
            setData( data = { ...data,
                uf: e
            })
            return null
        }else if(kind === "branch"){
            setData( data = { ...data,
                branch: e
            });
            return null
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/general/clientFormWrapper/handleInput.js